/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

export const wordCount = (s?: string) => {
  return s?.trim().split(/\s+/).length || 0
}
